import { useLanguage } from "@/i18n";
import Reveal from "@/components/Reveal";
import { Beer, Wine, Martini, CupSoda } from "lucide-react";

const ICONS = [Beer, CupSoda, Wine, Martini];

export default function BarMenu() {
  const { t } = useLanguage();
  return (
    <section id="bar" data-testid="bar-section" className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-ocean mb-4">{t.bar.kicker}</p>
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-lg">{t.bar.title}</h2>
          <p className="text-sm text-slate-400 italic max-w-xs">{t.bar.note}</p>
        </div>
      </Reveal>

      <div className="grid sm:grid-cols-2 gap-4 mb-4">
        {["/assets/bar-bier.png", "/assets/bar-fris.png"].map((src, i) => (
          <Reveal key={src} delay={i * 0.08}>
            <div className="rounded-2xl overflow-hidden border border-stroke group" data-testid={`bar-image-${i}`}>
              <img src={src} alt={t.bar.kicker} className="w-full h-56 sm:h-72 object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
          </Reveal>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {t.bar.groups.map((group, gi) => {
          const Icon = ICONS[gi % ICONS.length];
          return (
            <Reveal key={gi} delay={gi * 0.07}>
              <div className="h-full rounded-2xl border border-stroke bg-surface p-6 hover:border-sunset/50 transition-colors duration-500" data-testid={`bar-group-${gi}`}>
                <div className="flex items-center gap-3 mb-5">
                  <span className="w-10 h-10 rounded-full bg-sunset/10 text-sunset flex items-center justify-center">
                    <Icon size={17} />
                  </span>
                  <h3 className="font-display text-lg font-bold">{group.name}</h3>
                </div>
                <ul className="space-y-3">
                  {group.items.map((item, ii) => (
                    <li key={ii} className="flex items-baseline justify-between gap-3 text-sm" data-testid={`bar-item-${gi}-${ii}`}>
                      <span className="text-slate-300">{item.name}</span>
                      <span className="flex-1 border-b border-dotted border-stroke/80 mx-1" />
                      <span className="font-mono font-bold text-sand">{item.price}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
